module.exports = new __parcel__URL__("mining_cancel_dialog_cancel_button.3cc8a562.png").toString();